import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { FinancingModalTrigger } from "tsi-common-react/src/apps/financing/FinancingModalTrigger";
import { getDefaultFinancingPlan } from "tsi-common-react/src/utils/financing";
import { formatFinancingPlan } from "tsi-common-react/src/utils/format";
import { c, jt, t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import tempurCcSmall from "../../../assets/img/finance/tempur-cc-small.png";

import styles from "./index.module.scss";

type IProps = Immutable<{}> & {
    onRequestParentClose?: () => void;
};

const iconClasses = classNames({
    [styles.preApprovalAdIcon]: true,
    [styles.preApprovalAdIconFinance]: true,
    [styles.preApprovalAdIconCard]: true,
});

const buttonClasses = concatClassNames([
    "button",
    styles.preApprovalAdButton,
    "pre-approval-ad__apply",
    "al-financing-page__pre-approval-ad--apply-now",
    "al-financing-page__pre-approval-ad--apply-now-desktop",
]);

export const FinancingModalTriggerRetailModalPreapproval = (props: IProps) => {
    const plan = formatFinancingPlan(getDefaultFinancingPlan());
    const onOpen = () => {
        if (props.onRequestParentClose) {
            props.onRequestParentClose();
        }
    };
    return (
        <span>
            <div className={styles.root}>
                <img
                    className={iconClasses}
                    alt={t`Tempur-Pedic Credit Card`}
                    src={tempurCcSmall}
                    loading="lazy"
                    decoding="async"
                />
                <div className={styles.terms}>
                    {(() => {
                        const apr = (
                            <div
                                key="apr"
                                className={concatClassNames([
                                    styles.termsLine,
                                    styles.termsLine1,
                                ])}
                            >
                                {plan.apr}
                            </div>
                        );
                        const forLine = (
                            <div
                                key="for"
                                className={concatClassNames([
                                    styles.termsLine,
                                    styles.termsLine2,
                                ])}
                            >
                                <div className={styles.lineRule}></div>
                            </div>
                        );
                        const months = (
                            <div
                                key="months"
                                className={concatClassNames([
                                    styles.termsLine,
                                    styles.termsLine3,
                                ])}
                            >
                                {plan.length}
                                <sup>
                                    <a href="/finance-your-purchase#terms_and_conditions">
                                        {plan.superscript}
                                    </a>
                                </sup>
                            </div>
                        );
                        return jt`${apr} APR ${forLine} for ${months} Months`;
                    })()}
                </div>
                <div className={styles.see}>
                    <div className={styles.seeBold}>
                        {t`Check if you're pre-qualified`}
                    </div>
                    <div className={styles.seeSmall}>
                        {t`without affecting your credit score.`}
                    </div>
                </div>
                <FinancingModalTrigger
                    modalType="prequal-app"
                    className={buttonClasses}
                    title={t`Check Now`}
                    onClick={onOpen}
                >
                    {t`Check Now`}
                </FinancingModalTrigger>
            </div>
            <div className={concatClassNames([styles.root, styles.mobile])}>
                <div className={styles.terms}>
                    <div
                        className={concatClassNames([
                            styles.termsLine,
                            styles.termsLine1,
                        ])}
                    >
                        {c("FinancingModalTriggerRetailModalPreapproval")
                            .t`${plan.apr} APR for ${plan.length} Months`}
                        <sup>
                            <a href="/finance-your-purchase#terms_and_conditions">
                                {plan.superscript}
                            </a>
                        </sup>
                    </div>
                </div>
                <div className={styles.see}>
                    <div className={styles.seeSmall}>
                        {richT(
                            t`Check if you <prequalcopy>pre-qualify</prequalcopy> without affecting your credit score.`,
                            {
                                prequalcopy: (children) => (
                                    <FinancingModalTrigger
                                        modalType="prequal-app"
                                        title={t`Check Now`}
                                        onClick={onOpen}
                                    >
                                        {children}
                                    </FinancingModalTrigger>
                                ),
                            },
                        )}
                    </div>
                </div>
            </div>
        </span>
    );
};
